<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';

import AgentMessagesPieChart from './AgentMessagesPieChart.vue';
import AgentAttendancePieChart from './AgentAttendancePieChart.vue';
import TeamMessagesPieChart from './TeamMessagesPieChart.vue';
import TeamConversationsPieChart from './TeamConversationsPieChart.vue';
import AgentPerformanceBarChart from './AgentPerformanceBarChart.vue';
import TeamPerformanceBarChart from './TeamPerformanceBarChart.vue';

const store = useStore();

const fetchData = () => {
  const currentDate = new Date();
  const thirtyDaysAgo = new Date(
    currentDate.getTime() - 30 * 24 * 60 * 60 * 1000
  );

  const params = {
    since: Math.floor(thirtyDaysAgo.getTime() / 1000),
    until: Math.floor(currentDate.getTime() / 1000),
    businessHours: false,
  };

  store.dispatch('summaryReports/fetchAgentSummaryReports', params);
  store.dispatch('summaryReports/fetchTeamSummaryReports', params);
};

onMounted(() => {
  fetchData();
});
</script>

<template>
  <div class="flex flex-col gap-6 w-full max-w-full">
    <div class="flex flex-col gap-4 w-full">
      <h2 class="text-xl font-semibold text-n-slate-12 px-2">
        Relatórios de Agentes
      </h2>

      <div class="w-full max-w-full">
        <AgentPerformanceBarChart />
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full max-w-full">
        <div class="w-full max-w-full min-w-0">
          <AgentAttendancePieChart />
        </div>
        <div class="w-full max-w-full min-w-0">
          <AgentMessagesPieChart />
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4 w-full">
      <h2 class="text-xl font-semibold text-n-slate-12 px-2">
        Relatórios de Equipes
      </h2>

      <div class="w-full max-w-full">
        <TeamPerformanceBarChart />
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full max-w-full">
        <div class="w-full max-w-full min-w-0">
          <TeamConversationsPieChart />
        </div>
        <div class="w-full max-w-full min-w-0">
          <TeamMessagesPieChart />
        </div>
      </div>
    </div>
  </div>
</template>
